//Module Keys
let locales = {
    dashboardPanel_title: "PANEL",
    dashboardPanel_mutiple_title: "PANELES",
    dashboardPanel_preview: "Vista previa",
    dashboardPanel_add_gadget: "Agregar gadget",
    dashboardPanel_edit_gadget: "Editar gadget",
    dashboardPanel_edit_info: "En este momento, está editando su panel de control. Los cambios se guardarán automáticamente.",
    dashboardPanel_edit_frequency: "Frecuencia de actualización",
    dashboardPanel_edit_title: "Título",
    dashboardPanel_edit_minutes: "Minutos",
    dashboardPanel_edit_hours: "Horas",
    dashboardPanel_edit_days: "Días",
    dashboardPanel_edit_report_type: "Tipo de informe",
    dashboardPanel_edit_chart_type: "Tipo de gráfico",
    dashboardPanel_edit_groups_unit: "Etiquetas/Unidades",
    dashboardPanel_edit_time_metric: "Métrica del tiempo",
    dashboardPanel_edit_IdleTime: 'Tiempo de inactividad',
    dashboardPanel_edit_IdleStop: 'Idle Stop',
    dashboardPanel_edit_DriveTime: 'Tiempo de conducción',
    dashboardPanel_edit_DriverStop: 'Tiempo de parada',
    dashboardPanel_edit_Speeding: 'Exceso de velocidad',
    dashboardPanel_edit_Mileage: 'Kilometraje',
    dashboardPanel_edit_EngineTime: 'Tiempo del motor',
    dashboardPanel_edit_DriverOverview: 'Visión general de la conducción',
    dashboardPanel_edit_DriverSafety: 'Seguridad del conductor',
    dashboardPanel_edit_allUnits: 'Todas las unidades',
    dashboardPanel_edit_singleGroup: 'Etiqueta única',
    dashboardPanel_edit_compareGroup: 'Comparar etiquetas',
    dashboardPanel_edit_month: 'Mes',
    dashboardPanel_edit_week: 'Semana',
    dashboardPanel_edit_quarter: 'Cuarto',
    dashboardPanel_edit_chart_pie: 'Pastel',
    dashboardPanel_edit_chart_bar: 'Columna',
    dashboardPanel_edit_device_offline: 'Dispositivos fuera de línea',
    dashboardPanel_edit_chart: 'Gráficos',
    dashboardPanel_edit_fleet: "Categoría de dispositivo",
    dashboardPanel_offline_thresholdMinutes: "Umbral de tiempo",
    dashboardPanel_edit_group: "Grupo",
    dashboardPanel_edit_tag: "Etiqueta",
    dashboardPanel_edit_title_chart: 'Gráfico',
    dashboardPanel_edit_view: 'Ver',
    dashboardPanel_edit_percentage: 'En porcentaje',
    dashboardPanel_name: "Nombre del panel",
    dashboardPanel_rename: "Cambiar el nombre del panel de control",
    dashboardPanel_delete: "Borrar panel",
    dashboardPanel_title_new: "Nuevo panel",
    dashboardPanel_title_edit: "Editar el panel",
    dashboardPanel_chart_label_Mon: "Mon",
    dashboardPanel_chart_label_Tue: "Tue",
    dashboardPanel_chart_label_Wed: "Wed",
    dashboardPanel_chart_label_Thu: "Thu",
    dashboardPanel_chart_label_Fri: "Fri",
    dashboardPanel_chart_label_Sat: "Sat",
    dashboardPanel_chart_label_Sun: "Sun",
    dashboardPanel_chart_label_Jan: "Jan",
    dashboardPanel_chart_label_Feb: "Feb",
    dashboardPanel_chart_label_Mar: "Mar",
    dashboardPanel_chart_label_Apr: "Apr",
    dashboardPanel_chart_label_May: "May",
    dashboardPanel_chart_label_Jun: "Jun",
    dashboardPanel_chart_label_Jul: "Jul",
    dashboardPanel_chart_label_Aug: "Aug",
    dashboardPanel_chart_label_Sep: "Sep",
    dashboardPanel_chart_label_Oct: "Oct",
    dashboardPanel_chart_label_Nov: "Nov",
    dashboardPanel_chart_label_Dec: "Dec",
    dashboardPanel_to: "a",
};

//Merge Views
import main from 'Modules/accounts/views/main/lan/es';
import overview from 'Modules/accounts/views/overview/lan/es';
import purgeAccount from 'Modules/accounts/views/components/purgeAccount/lan/es';
import createAccount from 'Modules/accounts/views/components/createEditAccount/lan/es';
import changeStatusAccount from 'Modules/accounts/views/components/changeStatus/lan/es';
import resetCompanyAuthentication from 'Modules/accounts/views/components/resetCompanyAuthentication/lan/es';
import systemAlertLogsTab from 'Modules/accounts/.components/systemAlertLogsTab/lan/es';
import scheduledReports from 'Modules/accounts/.components/scheduledReports/lan/es';
import exportLogs from 'Modules/accounts/.components/exportLogs/lan/es';
import reprocessOdoHours from 'Modules/accounts/.components/reprocessOdoHours/lan/es';
import changeUsername from 'Modules/accounts/.components/changeUsername/lan/es';
import tabAccounts from 'Modules/accounts/.components/tab/lan/es';
import promilesRequest from 'Modules/accounts/views/components/promilesRequest/lan/es';
import tabIntegrations from 'Modules/accounts/.components/tabIntegrations/lan/es';
import addIntegration from 'Modules/accounts/.components/addIntegration/lan/es';
import viewCerebrumXIntegration from 'Modules/accounts/.components/viewCerebrumXIntegration/lan/es';
import addCerebrumXOEM from 'Modules/accounts/.components/addCerebrumXOEM/lan/es';
import deleteCerebrumXIntegration from 'Modules/accounts/.components/deleteCerebrumXIntegration/lan/es';
import syncEntities from 'Modules/accounts/views/components/syncEntities/lan/es';
import edgeTensor from 'Modules/accounts/.components/tabEdgeTensor/lan/es';
import edgeTensorVideoReview from 'Modules/accounts/.components/edgeTensorVideoReview/lan/es';
import tabApiKeys from 'Modules/accounts/.components/tabApiKeys/lan/es';

locales = {
    ...locales,
    ...main,
    ...overview,
    ...purgeAccount,
    ...createAccount,
    ...changeStatusAccount,
    ...resetCompanyAuthentication,
    ...systemAlertLogsTab,
    ...scheduledReports,
    ...exportLogs,
    ...reprocessOdoHours,
    ...changeUsername,
    ...tabAccounts,
    ...promilesRequest,
    ...tabIntegrations,
    ...addIntegration,
    ...viewCerebrumXIntegration,
    ...addCerebrumXOEM,
    ...deleteCerebrumXIntegration,
    ...syncEntities,
    ...edgeTensor,
    ...edgeTensorVideoReview,
    ...tabApiKeys
};

export default locales;